"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var title_1 = __importDefault(require("./title"));
var Layout = function (_a) {
    var children = _a.children, title = _a.title, classNames = _a.classNames;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(Grid_1["default"], { item: true, xs: 6, className: classNames === null || classNames === void 0 ? void 0 : classNames.titleContainer },
            react_1["default"].createElement(title_1["default"], { title: title, type: "pageTitle", className: classNames === null || classNames === void 0 ? void 0 : classNames.title })),
        children));
};
exports["default"] = Layout;
